/**
 * 路由错误边界
 * @module app/routes/RouteErrorBoundary
 */

import React from 'react';
import { Button, Result, Typography } from 'antd';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

const { Paragraph, Text } = Typography;

const RouteErrorBoundary: React.FC = () => {
  const error = useRouteError();

  const title = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : '页面加载失败';

  const message = isRouteErrorResponse(error)
    ? error.data?.message || '请求失败，请稍后再试。'
    : error instanceof Error
      ? error.message
      : '发生未知错误。';

  const stack = error instanceof Error ? error.stack : undefined;

  return (
    <Result
      status="error"
      title={title}
      subTitle="加载页面时发生错误，请尝试刷新或返回首页。"
      extra={[
        <Button key="home" type="primary" href="/">
          返回首页
        </Button>,
        <Button key="reload" onClick={() => window.location.reload()}>
          刷新
        </Button>,
      ]}
    >
      <Paragraph>
        <Text strong>错误信息：</Text>
        <Text type="secondary">{message}</Text>
      </Paragraph>
      {stack && (
        <Paragraph>
          <Text strong>堆栈：</Text>
          <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{stack}</pre>
        </Paragraph>
      )}
    </Result>
  );
};

export default RouteErrorBoundary;
